<template>
    <div id="edit-password-employee-page">
        <ui5-button @click="updatePasswordEmployee">{{ trans('pages.edit_password_employee.save') }}</ui5-button>
        <ui5-button @click="$router.push('/employees')">{{ trans('pages.edit_password_employee.cancel') }}</ui5-button>

        <div id="editemployeefields">
            <div class="field">
                <ui5-label for="employee-password">{{ trans('pages.edit_password_employee.new_password_label') }}</ui5-label>
                <ui5-input
                    type="Password"
                    id="employee-password"
                    :value="password"
                    @input="password = $event.target.value" />
            </div>
        </div>
    </div>
</template>
<script>
import userApi from '../api/user';
import IdParamMixin from '../mixins/id-param';
import { showInfoMessage, showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    mixins: [IdParamMixin(), localization],
    data() {
        return {
            password: '',
        };
    },
    methods: {
        updatePasswordEmployee() {
            userApi
                .updateUserPassword(this.idParam, this.password)
                .then(() => {
                    this.$router.push('/employees');
                    showInfoMessage(this.trans('pages.edit_password_employee.success_message'));
                })
                .catch(() => {
                    showErrorMessage(this.trans('pages.edit_password_employee.error_message'));
                });
        },
    },
};
</script>
